<ng-container>
  <!-- <div class="home__sucursalicon">
    <i class="fas fa-home"></i>
  </div> -->
  <div class="d-inline-flex f-s-11">
    <!-- <span class="bold">{{$branchoffice->description}}</span>, -->
    <div class="hide-xs d-inline-flex">
      <span class="fas fa-toolbox m-l-10 m-r-5 f-s-15"></span>
      <ng-container *ngIf="check_moneybox">
        <ng-container *ngIf="moneybox != null">
          <div class="d-inline position-relative " style="margin-top: -2px">
            <ng-container *ngIf="moneybox.status_closed == false">
              <span class="badge badge-primary money__opening__principal__info f-s-10">
                Caja abierta
              </span>
            </ng-container>
            <ng-container *ngIf="moneybox.status_closed == true">
              <span class="badge badge-danger money__opening__principal__info">
                Caja cerrada
              </span>
            </ng-container>
            <ng-container *ngIf="moneybox.is_before == true">
              <span class="badge badge-warning money__opening__principal__info f-s-10" ng-if="moneybox.is_before">
                CAJA ANTERIOR : {{moneybox.date_opening | date: 'mediumDate'}}
              </span>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!check_moneybox">
        <div class="d-inline position-relative m-l-5" style="margin-top: -3px">
          <div class="alert alert-danger fade show m-b-0" style="padding: 2px 7px !important" role="alert">
            <span class="f-s-10">
              Aperturar caja,
              <a style="text-decoration: underline" routerLink="/{{branchofficeSlug}}/caja/apertura" class="text-white bold">Ir a caja.</a>
            </span>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
</ng-container>
